export const locale = {
    lang: 'tr',
    data: {
        'WELCOME': {
            'HELLO': 'Merhaba Dünya!'
        }
    }
};
